import api from "helpers/api";
import { defaultAreaTypes } from 'helpers/constants';

export const createParking = () => { };
export const updateParking = () => { };
export const getParkingById = () => { };

export const getParkingSpaceList = async (param: any = {}) => {
    try {
        const response = await api.post("/facility/ipms_space", param);

        const ipmsSpaceList = response.spaceList;
        const areaNameList = response.areaNameList;
        const entryList = response.entryList;

        const totalSpaces = ipmsSpaceList.totalSpace;

        const fullSlotList = Array.from({ length: totalSpaces }, (_, i) => {
            const spaceNumber = (i + 1).toString();
            const areaInfo = areaNameList.find(a => a.spaceNumber === spaceNumber);
            const usedSlot = entryList.find(entry => entry.spaceNumber?.split(",").includes(spaceNumber));
            let areaName = '';
            let areaTypeName = '';
            if (param?.page === 'parkingSetting') {
                areaName = areaInfo?.areaName || `${spaceNumber}번`;
                areaTypeName = areaInfo?.areaTypeName || (areaInfo?.defaultType ? defaultAreaTypes[areaInfo.defaultType] : defaultAreaTypes['NORMAL']);
            } else if (usedSlot?.entryId) {
                areaName = usedSlot?.areaName || `${spaceNumber}번`;
                areaTypeName = usedSlot?.areaTypeName || defaultAreaTypes['NORMAL'];
            } else {
                areaName = areaInfo?.areaName || `${spaceNumber}번`;
                areaTypeName = areaInfo?.areaTypeName || (areaInfo?.defaultType ? defaultAreaTypes[areaInfo.defaultType] : defaultAreaTypes['NORMAL']);
            }
            return {
                parkingId: usedSlot?.parkingId || "",
                spaceNumber: spaceNumber,
                areaTypeId: usedSlot?.areaTypeId || null,
                areaName: areaName,
                areaTypeName: areaTypeName,
                carNum: usedSlot?.carNum || null,
                entryId: usedSlot?.entryId || null,
                inTime: usedSlot?.inTime || null,
                outTime: usedSlot?.outTime || null,
                inImageLink: usedSlot?.inImageLink || null,
                payStatusCd: usedSlot?.payStatusCd || null,
                membership: usedSlot?.membership || null,
                membershipTypeCd: usedSlot?.membershipTypeCd || null,
            };
        });
        return {
            parkingName: ipmsSpaceList.parkingName,
            fullSlotList: fullSlotList,
        }
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch parking space list");
    }
};

export const searchCar = async (param: any = {}) => {
    try {
        const response = await api.post("/facility/list_car_num", param);
        const usedSlot = [];
        response.list.forEach((spot) => {
            let areaName = '';
            let areaTypeName = '';
            if (spot?.entryId) {
                areaName = spot?.areaName || `${spot?.spaceNumber}번`;
                areaTypeName = spot?.areaTypeName || defaultAreaTypes['NORMAL'];
            }
            usedSlot.push({
                ...spot,
                areaName: areaName,
                areaTypeName: areaTypeName,
            });
        });

        usedSlot.sort((a, b) => {
            const numA = Number(a.spaceNumber);
            const numB = Number(b.spaceNumber);
            return numA - numB;
        });
        return {
            ...response,
            usedSlot: usedSlot
        };
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch car list");
    }
}

export const getParkingSpaceName = async (parkingId: string, spaceNumber: string) => {
    try {
        const response = await api.post("/facility/parking_space", {
            parkingId: parkingId,
            spaceNumber: spaceNumber,
        });
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch parking space name");
    }
}

export const getAreaTypeList = async (parkingId: string) => {
    try {
        const response = await api.post("/facility/area_type_list", {
            parkingId: parkingId,
        });
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch area type list");
    }
}

export const getAreaTypeDetail = async (parkingId: string, areaTypeId: string) => {
    try {
        const response = await api.post("/facility/area_type_detail", {
            parkingId: parkingId,
            areaTypeId: areaTypeId
        });
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch area type");
    }
}

export const insertOrUpdateSpaceName = async (data: any) => {
    try {
        const response = await api.post("/facility/edit_space_name", {
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to update list");
    }
}

export const updateAreaType = async (data: any) => {
    try {
        const response = await api.post("/facility/edit_area_type", {
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch area type list");
    }
}

export const getUnpaidList = async (data: any) => {
    try {
        const response = await api.post("/facility/unpaid_list_new", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch unpaid list");
    }
}

export const getParkingStatistics = async (data: any) => {
    try {
        const response = await api.post("/facility/parking_statistic", data);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch parking statistics");
    }
}

export const getParkingSpaceUsingList = async (param: any = {}) => {
    try {
        const response = await api.post("/facility/ipms_space_using", param);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch parking space list");
    }
}